<template>
  <generic-list :options="options"> </generic-list>
</template>

<script>
import GenericList from "@/pages/Lists/GenericList.vue";
const baseRoute = "destination";
export default {
  components: {
    GenericList,
  },
  data() {
    return {
      options: {
        capability: baseRoute,
        actions: {
          edit: {
             routeName: "Gestione Destinazioni",
             path: baseRoute,
          },
          new: {
            title: "Nuova Destinazione",
            route: "Gestione Destinazioni",
          },
        },
        columns: [
          {
            label: "ID",
            field: "id",
            type: "number",
            html: false,
            tdClass: "text-center",
            thClass: "text-center",
            sortable: true,
          },
          {
            label: "TITOLO",
            field: "title",
            filterable: true,
            sortable: false,
          },
          {
            label: "STATO",
            field: "status",
            filterable: false,
            html: true,
            tdClass: "text-center",
            thClass: "text-center",
            sortable: false,
          },
        ],

        apiGetRoute: this.$url + "destination",
        apiDeleteRoute: this.$url + "destination",
        mapper: this.itemMapper,
      },
    };
  },

  methods: {
    itemMapper(item) {
      return {
        id: item.id,
        title: item.contents["it"].title,
        contents: item.contents,
      };
    },
  },
};
</script>
